export default class GetCategorias {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute() {
    try {
      const result = await this.#repository.getAllCategorias()
      return result
    } catch (error) {
      throw error
    }
  }
}
